import { useToastContext } from './context/ToastContext';

import closeIcon from 'assets/icons/Close.svg';

import SvgIcon from 'shared/components/SvgIcon/SvgIcon';

// CSS modules
import './Toast.style.scss';

/**
 * Global toast notification banner.
 * Subscribes to {@link ToastContext} and renders a dismissible banner
 * when a toast is active. Supports `'success'` and `'error'` types
 * which map to CSS class variants for colour styling.
 *
 * Place this component once at the application root (alongside the provider)
 * so it is always accessible regardless of routing.
 */
export default function Toast(): JSX.Element {
	const { show, closeToast, type, text } = useToastContext();

	return (
		<>
			{show ? (
				<div className={`globalToast ${type}`}>
					<p>{text}</p>
					<SvgIcon spriteUrl={closeIcon} className="toastCloseIcon" onClick={closeToast} />
				</div>
			) : null}
		</>
	);
}
